import { Alert, Box } from "@mui/material";
import { useGetIdentity } from "react-admin";
import { EditableGrid, EditorField } from "@/components/common/EditableGrid";
import { TabContent } from "@/components/common/PageLayout";
import { ShowAccordionSection } from "@/components/common/ShowAccordionSection";
import { AlertType, ResourceName } from "@/types";
import { useResourcePermissions } from "@/hooks/useResourcePermissions";
import { PandaDocConfigSection } from "./PandaDocConfigSection";

export const PartnerOverviewTab = () => {
  const { canEdit } = useResourcePermissions(ResourceName.PARTNERS);
  const { data: identity } = useGetIdentity();
  const isSuperAdmin =
    identity?.assignedRoles?.some((ar: { role: { name: string } }) => ar.role.name === "SuperAdmin") ?? false;

  return (
    <TabContent>
      {!canEdit && (
        <Box mb={2}>
          <Alert severity={AlertType.INFO}>
            Contact Aegle Capital if you need to make changes to your partner configuration.
          </Alert>
        </Box>
      )}
      <ShowAccordionSection label="Partner Information" defaultExpanded>
        <EditableGrid fields={partnerInfoFields} recordType={ResourceName.PARTNERS} />
      </ShowAccordionSection>
      <ShowAccordionSection label="General Settings" defaultExpanded>
        <EditableGrid fields={generalConfigFields} recordType={ResourceName.PARTNERS} />
      </ShowAccordionSection>
      {isSuperAdmin && (
        <ShowAccordionSection label="PandaDoc Settings" defaultExpanded>
          <PandaDocConfigSection />
        </ShowAccordionSection>
      )}
    </TabContent>
  );
};

const partnerInfoFields: EditorField[] = [
  { source: "partner_company_name" },
  { source: "partner_code" },
  { source: "domain" },
  { source: "accel_product_name" },
];

const generalConfigFields: EditorField[] = [
  { source: "configuration.api_endpoint" },
  { source: "configuration.timeout", type: "number" },
  { source: "configuration.workflow_model" },
];
